export enum SmsTypes {
  AdherenceAutomated = 'adherence-automated',
  AutomatedResponse = 'automated-response',
  User = 'user',
  Unknown = 'unknown',
  Incoming = 'incoming',
  Campaign = 'campaign',
}
